module.exports = __webpack_public_path__ + "media/80.afd13e10.mp3";